import React, { useEffect, useState } from 'react';
import { EllipsisIcon } from '@fiverr-private/visuals';
import { Popover, PopoverAnchor, PopoverContent } from '@fiverr-private/popover';
import { Stack } from '@fiverr-private/layout_components';
import { ReportAnIssueButton, useReportingContext } from '@fiverr-private/content_reporting';
import { IconButton } from '@fiverr-private/button';

export const ReportPopover: React.FC = () => {
  const { fetchEligibility, isModalOpen } = useReportingContext();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      setIsOpen(false);
    }
  }, [isModalOpen]);

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const opening = !isOpen;
    setIsOpen(opening);
    if (opening) {
      fetchEligibility();
    }
  };

  return (
    <Popover isOpen={isOpen} onOpenChanged={setIsOpen} position="bottom-end">
      <PopoverAnchor>
        <IconButton
          intent="primary"
          variant="filled"
          size="xs"
          className="slide-overlay-btn"
          aria-label="More options"
          onClick={handleButtonClick}
        >
          <EllipsisIcon />
        </IconButton>
      </PopoverAnchor>
      <PopoverContent disablePadding renderWhenClosed appendToBody>
        <Stack margin="2" direction="column" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
          <ReportAnIssueButton variant="button" shouldTriggerAuth shouldTriggerActivation />
        </Stack>
      </PopoverContent>
    </Popover>
  );
};
